import styled from "styled-components";

export const ProfileContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
//   background: var(--background, #f4f4f4); // Inherits from parent theme
  font-family: inherit; // Uses parent font
`;

export const ProfileCard = styled.div`
  background-color: black;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 90%;
  max-width: 550px;
  transition: 0.3s ease-in-out;
`;

export const Avatar = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 15px;
  object-fit: cover;
  border: 3px solid var(--primary, #007bff);
`;

export const Name = styled.h2`
//   color: white;
  font-size: 1.2rem;
  margin-bottom: 10px;
  color: var(--text-color, #333); // Inherits from parent
`;

export const ButtonGroup = styled.div`
  display: flex;
//   flex-direction: column;
  gap: 10px;
  margin-top: 15px;
`;

export const ProfileButton = styled.button`
  padding: 10px 15px;
  border: none;
  background: var(--primary, #007bff);
  color: var(--button-text, white);
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: 0.3s ease-in-out;
  font-family: inherit;

  &:hover {
    background: var(--primary-dark, #0056b3);
  }

  @media (min-width: 768px) {
    padding: 12px 20px;
  }
`;
